import { z } from "zod";
import { UIElementType } from "../../../../AppConstants";
import { AppUtility } from "../../../../utils/utility";
import { t } from "i18next";

const getPezodeRangeSchema = (lookUpData, existingRanges) => {
    return z.object({
        MininumInputValue: z
            .number()
            .positive()
            .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("createPezodeRange.minimumInputValue"), isRequired: true })),
        MaximumInputValue: z
            .number()
            .positive()
            .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("createPezodeRange.maximumInputValue"), isRequired: true })),
        OutputUnit: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Output Unit is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createPezodeRange.outputUnit"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.outputUnitList ? lookUpData.outputUnitList : []
                })
            ),
        OutputUnitValue: z
            .number()
            .positive()
            .describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createPezodeRange.outputUnitValue"),
                    subtext: "(Number of devices per ‘x’ meters( measurement unit))",
                    isRequired: true
                })),
        OutputValue: z
            .number()
            .positive()
            .describe(
                JSON.stringify({
                    inputType: "number",
                    elementType: UIElementType.TEXTFIELD,
                    inputLabel: t("createPezodeRange.outputValue"),
                    subtext: "(Spacing distance between each device)",
                    isRequired: true
                })),
        Summation: z.union([z.literal(0), z.number().positive()])
            .nullable()
            .refine(value => value === null || value >= 0, {
                message: "If entered, the number must be positive or zero",
            })
            .describe(JSON.stringify({ inputType: "number", elementType: UIElementType.TEXTFIELD, inputLabel: t("createPezodeRange.summation"), isRequired: false }))
    }).superRefine((data, ctx) => {
        const startRange = data.MininumInputValue;
        const endRange = data.MaximumInputValue;

        // Check if both ranges are provided
        if (startRange !== null && endRange !== null) {
            // Check if end range is greater than start range
            if (endRange <= startRange) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "Minimum input value should be less than the maximum input value.",
                    path: ["MaximumInputValue"],
                });
            }

            // Check if the range overlaps with existing ranges
            if (AppUtility.isNotValidRange(startRange, endRange, existingRanges)) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: "The entered range overlaps with an existing range",
                    path: ["MininumInputValue"],
                });
            }
        }
    });
};

const getPezodeRangeDefaultValue = (value = null) => {
    console.log("value" + JSON.stringify(value));
    return {
        MininumInputValue: value ? value?.MininumInputValue : null,
        MaximumInputValue: value ? value?.MaximumInputValue : null,
        OutputUnit: value ? value?.OutputUnit : null,
        OutputUnitValue: value ? value?.OutputUnitValue : null,
        OutputValue: value ? value?.OutputValue : null,
        Summation: value ? value?.Summation : 0,
        PezodeRangeId: value ? value?.PezodeRangeId : null,
    };
};

export { getPezodeRangeSchema, getPezodeRangeDefaultValue };